import forOwn from 'lodash/forOwn';
import isString from 'lodash/isString';
import PhoneNumberPattern from '../enums/phone-number-pattern';
function isPhoneNumber(phoneNumber) {
  var isPhone = false;
  if (isString(phoneNumber)) {
    var ausNumber = phoneNumber.trim().replace(/\s/g, '');
    ausNumber = ausNumber.replace('+6113', '13');
    ausNumber = ausNumber.replace('+6118', '18');
    ausNumber = ausNumber.replace('+61', '0');
    forOwn(PhoneNumberPattern, pattern => {
      if (ausNumber.match(pattern) !== null) {
        isPhone = Boolean(ausNumber.match(pattern));
      }
    });
  }
  return isPhone;
}
export default isPhoneNumber;